/* ============================================================
   LEOSPORTZ — theme-cart.js
   Cart drawer: open/close, refresh, add, remove, render.
   ============================================================ */

(function () {
'use strict';

window.Leosportz = window.Leosportz || {};
const { $, $$, on, formatMoney } = Leosportz.utils;

Leosportz.CartDrawer = (() => {
  let drawerEl, overlayEl;

  function init() {
    drawerEl  = $('.cart-drawer');
    overlayEl = $('.cart-overlay');
    if (!drawerEl) return;

    $$('[data-cart-open]').forEach(btn => on(btn, 'click', open));
    $$('[data-cart-close], .cart-drawer__close').forEach(btn => on(btn, 'click', close));
    on(overlayEl, 'click', close);
    on(document, 'keydown', e => { if (e.key === 'Escape') close(); });

    // Delegate remove clicks
    on(drawerEl, 'click', e => {
      const removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) {
        e.preventDefault();
        const line = parseInt(removeBtn.dataset.cartRemove, 10);
        removeLine(line);
      }
    });

    refreshCart();
  }

  function open()  { drawerEl?.classList.add('is-open');  overlayEl?.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  function close() { drawerEl?.classList.remove('is-open'); overlayEl?.classList.remove('is-open'); document.body.style.overflow = ''; }

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      renderCart(cart);
    } catch (err) {
      console.error('Cart refresh failed:', err);
    }
  }

  function renderCart(cart) {
    const itemsContainer = drawerEl.querySelector('.cart-drawer__body');
    const subtotalEl = drawerEl.querySelector('.cart-drawer__subtotal');
    const totalEl = drawerEl.querySelector('.cart-drawer__total-amount');
    const countEls = $$('[data-cart-count]');
    const footerEl = drawerEl.querySelector('.cart-drawer__footer');
    const shippingProgress = drawerEl.querySelector('.cart-drawer__shipping-progress');

    if (!itemsContainer) return;

    if (cart.item_count === 0) {
      itemsContainer.innerHTML = '<div class="cart-drawer__empty"><div class="cart-drawer__empty-icon">🛒</div><div class="cart-drawer__empty-title">Your cart is empty</div><p class="cart-drawer__empty-text">Add some gear and get moving!</p></div>';
      if (footerEl) footerEl.style.display = 'none';
    } else {
      if (footerEl) footerEl.style.display = '';
      itemsContainer.innerHTML = cart.items.map((item, idx) => `
        <div class="cart-item" data-key="${item.key}" data-line="${idx + 1}">
          <div class="cart-item__img"><img src="${item.image}" alt="${item.title}" loading="lazy"></div>
          <div class="cart-item__info">
            <div class="cart-item__name">${item.product_title}</div>
            <div class="cart-item__variant">${item.variant_title || ''}</div>
            <div class="cart-item__row">
              <div class="cart-item__price">${formatMoney(item.final_line_price)}</div>
              <button class="cart-item__remove" data-cart-remove="${idx + 1}">Remove</button>
            </div>
          </div>
        </div>
      `).join('');
    }

    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    countEls.forEach(el => { el.textContent = cart.item_count; });

    // Update free shipping progress
    if (shippingProgress) {
      const threshold = parseInt(shippingProgress.dataset.shippingThreshold, 10);
      const remaining = threshold - cart.total_price;
      const pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
      const fill = shippingProgress.querySelector('.cart-drawer__shipping-fill');
      const text = shippingProgress.querySelector('.cart-drawer__shipping-text');
      if (fill) fill.style.width = pct + '%';
      if (text) {
        if (remaining <= 0) {
          text.innerHTML = '<span style="color:var(--color-primary-action);font-weight:600">🎉 You unlocked free shipping!</span>';
        } else {
          text.innerHTML = `Add <strong>${formatMoney(remaining)}</strong> more for <strong>FREE shipping</strong>`;
        }
      }
    }
  }

  async function addItem(variantId, qty = 1) {
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty }),
      });
      if (!res.ok) throw new Error('Add to cart failed');
      await refreshCart();
      open();
    } catch (err) {
      console.error('Add to cart failed:', err);
      alert('Could not add item to cart. Please try again.');
    }
  }

  async function removeLine(line) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: 0 }),
      });
      if (!res.ok) throw new Error('Remove failed');
      await refreshCart();
    } catch (err) {
      console.error('Remove failed:', err);
    }
  }

  return { init, open, close, addItem, refreshCart };
})();

})();
